@file:OptIn(InternalResourceApi::class)

package advancedmpkeditor.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/advancedmpkeditor.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_488_608_978)
internal val Res.drawable.brain_coral: DrawableResource by lazy {
      DrawableResource("drawable:brain_coral", setOf(
        ResourceItem(setOf(), "${MD}drawable/brain_coral.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(880_912_331)
internal val Res.drawable.brain_coral_block: DrawableResource by lazy {
      DrawableResource("drawable:brain_coral_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/brain_coral_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-699_770_556)
internal val Res.drawable.brain_coral_fan: DrawableResource by lazy {
      DrawableResource("drawable:brain_coral_fan", setOf(
        ResourceItem(setOf(), "${MD}drawable/brain_coral_fan.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_503_349_809)
internal val Res.drawable.bread: DrawableResource by lazy {
      DrawableResource("drawable:bread", setOf(
        ResourceItem(setOf(), "${MD}drawable/bread.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_966_472_147)
internal val Res.drawable.brewing_stand: DrawableResource by lazy {
      DrawableResource("drawable:brewing_stand", setOf(
        ResourceItem(setOf(), "${MD}drawable/brewing_stand.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-673_343_649)
internal val Res.drawable.brick: DrawableResource by lazy {
      DrawableResource("drawable:brick", setOf(
        ResourceItem(setOf(), "${MD}drawable/brick.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_709_453_507)
internal val Res.drawable.brick_slab: DrawableResource by lazy {
      DrawableResource("drawable:brick_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/brick_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_330_111_821)
internal val Res.drawable.brick_stairs: DrawableResource by lazy {
      DrawableResource("drawable:brick_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/brick_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_809_086_855)
internal val Res.drawable.brick_wall: DrawableResource by lazy {
      DrawableResource("drawable:brick_wall", setOf(
        ResourceItem(setOf(), "${MD}drawable/brick_wall.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(760_430_834)
internal val Res.drawable.bricks: DrawableResource by lazy {
      DrawableResource("drawable:bricks", setOf(
        ResourceItem(setOf(), "${MD}drawable/bricks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(224_151_601)
internal val Res.drawable.brown_banner: DrawableResource by lazy {
      DrawableResource("drawable:brown_banner", setOf(
        ResourceItem(setOf(), "${MD}drawable/brown_banner.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-626_955_634)
internal val Res.drawable.brown_bed: DrawableResource by lazy {
      DrawableResource("drawable:brown_bed", setOf(
        ResourceItem(setOf(), "${MD}drawable/brown_bed.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_151_233_317)
internal val Res.drawable.brown_carpet: DrawableResource by lazy {
      DrawableResource("drawable:brown_carpet", setOf(
        ResourceItem(setOf(), "${MD}drawable/brown_carpet.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_418_066_375)
internal val Res.drawable.brown_concrete: DrawableResource by lazy {
      DrawableResource("drawable:brown_concrete", setOf(
        ResourceItem(setOf(), "${MD}drawable/brown_concrete.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_339_043_532)
internal val Res.drawable.brown_concrete_powder: DrawableResource by lazy {
      DrawableResource("drawable:brown_concrete_powder", setOf(
        ResourceItem(setOf(), "${MD}drawable/brown_concrete_powder.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_932_312_099)
internal val Res.drawable.brown_dye: DrawableResource by lazy {
      DrawableResource("drawable:brown_dye", setOf(
        ResourceItem(setOf(), "${MD}drawable/brown_dye.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-692_778_145)
internal val Res.drawable.brown_glazed_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:brown_glazed_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/brown_glazed_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(981_969_499)
internal val Res.drawable.brown_mushroom: DrawableResource by lazy {
      DrawableResource("drawable:brown_mushroom", setOf(
        ResourceItem(setOf(), "${MD}drawable/brown_mushroom.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_072_674_319)
internal val Res.drawable.brown_mushroom_block: DrawableResource by lazy {
      DrawableResource("drawable:brown_mushroom_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/brown_mushroom_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_912_559_529)
internal val Res.drawable.brown_shulker_box: DrawableResource by lazy {
      DrawableResource("drawable:brown_shulker_box", setOf(
        ResourceItem(setOf(), "${MD}drawable/brown_shulker_box.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(441_548_728)
internal val Res.drawable.brown_stained_glass: DrawableResource by lazy {
      DrawableResource("drawable:brown_stained_glass", setOf(
        ResourceItem(setOf(), "${MD}drawable/brown_stained_glass.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_205_114_882)
internal val Res.drawable.brown_stained_glass_pane: DrawableResource by lazy {
      DrawableResource("drawable:brown_stained_glass_pane", setOf(
        ResourceItem(setOf(), "${MD}drawable/brown_stained_glass_pane.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-257_583_765)
internal val Res.drawable.brown_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:brown_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/brown_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(939_111_535)
internal val Res.drawable.brown_wool: DrawableResource by lazy {
      DrawableResource("drawable:brown_wool", setOf(
        ResourceItem(setOf(), "${MD}drawable/brown_wool.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_017_095_552)
internal val Res.drawable.bubble_coral: DrawableResource by lazy {
      DrawableResource("drawable:bubble_coral", setOf(
        ResourceItem(setOf(), "${MD}drawable/bubble_coral.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(581_586_483)
internal val Res.drawable.bubble_coral_block: DrawableResource by lazy {
      DrawableResource("drawable:bubble_coral_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/bubble_coral_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-698_465_594)
internal val Res.drawable.bubble_coral_fan: DrawableResource by lazy {
      DrawableResource("drawable:bubble_coral_fan", setOf(
        ResourceItem(setOf(), "${MD}drawable/bubble_coral_fan.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_410_765_296)
internal val Res.drawable.bucket: DrawableResource by lazy {
      DrawableResource("drawable:bucket", setOf(
        ResourceItem(setOf(), "${MD}drawable/bucket.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(658_887_775)
internal val Res.drawable.cactus: DrawableResource by lazy {
      DrawableResource("drawable:cactus", setOf(
        ResourceItem(setOf(), "${MD}drawable/cactus.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-271_604_472)
internal val Res.drawable.cake: DrawableResource by lazy {
      DrawableResource("drawable:cake", setOf(
        ResourceItem(setOf(), "${MD}drawable/cake.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-639_856_873)
internal val Res.drawable.campfire: DrawableResource by lazy {
      DrawableResource("drawable:campfire", setOf(
        ResourceItem(setOf(), "${MD}drawable/campfire.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(735_635_583)
internal val Res.drawable.carrot: DrawableResource by lazy {
      DrawableResource("drawable:carrot", setOf(
        ResourceItem(setOf(), "${MD}drawable/carrot.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_086_301_027)
internal val Res.drawable.carrot_on_a_stick: DrawableResource by lazy {
      DrawableResource("drawable:carrot_on_a_stick", setOf(
        ResourceItem(setOf(), "${MD}drawable/carrot_on_a_stick.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(344_060_489)
internal val Res.drawable.cartography_table: DrawableResource by lazy {
      DrawableResource("drawable:cartography_table", setOf(
        ResourceItem(setOf(), "${MD}drawable/cartography_table.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_696_730_380)
internal val Res.drawable.carved_pumpkin: DrawableResource by lazy {
      DrawableResource("drawable:carved_pumpkin", setOf(
        ResourceItem(setOf(), "${MD}drawable/carved_pumpkin.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_145_580_238)
internal val Res.drawable.cat_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:cat_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/cat_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_084_069_654)
internal val Res.drawable.cauldron: DrawableResource by lazy {
      DrawableResource("drawable:cauldron", setOf(
        ResourceItem(setOf(), "${MD}drawable/cauldron.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-854_745_062)
internal val Res.drawable.cave_spider_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:cave_spider_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/cave_spider_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_101_385_665)
internal val Res.drawable.chain: DrawableResource by lazy {
      DrawableResource("drawable:chain", setOf(
        ResourceItem(setOf(), "${MD}drawable/chain.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(998_413_140)
internal val Res.drawable.chain_command_block: DrawableResource by lazy {
      DrawableResource("drawable:chain_command_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/chain_command_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-599_447_486)
internal val Res.drawable.chainmail_boots: DrawableResource by lazy {
      DrawableResource("drawable:chainmail_boots", setOf(
        ResourceItem(setOf(), "${MD}drawable/chainmail_boots.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_029_830_606)
internal val Res.drawable.chainmail_chestplate: DrawableResource by lazy {
      DrawableResource("drawable:chainmail_chestplate", setOf(
        ResourceItem(setOf(), "${MD}drawable/chainmail_chestplate.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_049_480_601)
internal val Res.drawable.chainmail_helmet: DrawableResource by lazy {
      DrawableResource("drawable:chainmail_helmet", setOf(
        ResourceItem(setOf(), "${MD}drawable/chainmail_helmet.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(528_289_501)
internal val Res.drawable.chainmail_leggings: DrawableResource by lazy {
      DrawableResource("drawable:chainmail_leggings", setOf(
        ResourceItem(setOf(), "${MD}drawable/chainmail_leggings.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(191_624_145)
internal val Res.drawable.charcoal: DrawableResource by lazy {
      DrawableResource("drawable:charcoal", setOf(
        ResourceItem(setOf(), "${MD}drawable/charcoal.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_010_564_929)
internal val Res.drawable.chest: DrawableResource by lazy {
      DrawableResource("drawable:chest", setOf(
        ResourceItem(setOf(), "${MD}drawable/chest.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_966_071_751)
internal val Res.drawable.chest_minecart: DrawableResource by lazy {
      DrawableResource("drawable:chest_minecart", setOf(
        ResourceItem(setOf(), "${MD}drawable/chest_minecart.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-484_319_249)
internal val Res.drawable.chicken: DrawableResource by lazy {
      DrawableResource("drawable:chicken", setOf(
        ResourceItem(setOf(), "${MD}drawable/chicken.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(75_564_902)
internal val Res.drawable.chicken_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:chicken_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/chicken_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(783_924_053)
internal val Res.drawable.chipped_anvil: DrawableResource by lazy {
      DrawableResource("drawable:chipped_anvil", setOf(
        ResourceItem(setOf(), "${MD}drawable/chipped_anvil.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(825_276_126)
internal val Res.drawable.chiseled_nether_bricks: DrawableResource by lazy {
      DrawableResource("drawable:chiseled_nether_bricks", setOf(
        ResourceItem(setOf(), "${MD}drawable/chiseled_nether_bricks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_297_022_316)
internal val Res.drawable.chiseled_polished_blackstone: DrawableResource by lazy {
      DrawableResource("drawable:chiseled_polished_blackstone", setOf(
        ResourceItem(setOf(), "${MD}drawable/chiseled_polished_blackstone.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-210_833_634)
internal val Res.drawable.chiseled_quartz_block: DrawableResource by lazy {
      DrawableResource("drawable:chiseled_quartz_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/chiseled_quartz_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-833_115_022)
internal val Res.drawable.chiseled_red_sandstone: DrawableResource by lazy {
      DrawableResource("drawable:chiseled_red_sandstone", setOf(
        ResourceItem(setOf(), "${MD}drawable/chiseled_red_sandstone.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_145_716_812)
internal val Res.drawable.chiseled_sandstone: DrawableResource by lazy {
      DrawableResource("drawable:chiseled_sandstone", setOf(
        ResourceItem(setOf(), "${MD}drawable/chiseled_sandstone.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-300_166_474)
internal val Res.drawable.chiseled_stone_bricks: DrawableResource by lazy {
      DrawableResource("drawable:chiseled_stone_bricks", setOf(
        ResourceItem(setOf(), "${MD}drawable/chiseled_stone_bricks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_545_290_285)
internal val Res.drawable.chorus_flower: DrawableResource by lazy {
      DrawableResource("drawable:chorus_flower", setOf(
        ResourceItem(setOf(), "${MD}drawable/chorus_flower.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_066_239_518)
internal val Res.drawable.chorus_fruit: DrawableResource by lazy {
      DrawableResource("drawable:chorus_fruit", setOf(
        ResourceItem(setOf(), "${MD}drawable/chorus_fruit.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-95_751_315)
internal val Res.drawable.chorus_plant: DrawableResource by lazy {
      DrawableResource("drawable:chorus_plant", setOf(
        ResourceItem(setOf(), "${MD}drawable/chorus_plant.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_421_708_785)
internal val Res.drawable.clay: DrawableResource by lazy {
      DrawableResource("drawable:clay", setOf(
        ResourceItem(setOf(), "${MD}drawable/clay.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-531_679_295)
internal val Res.drawable.clay_ball: DrawableResource by lazy {
      DrawableResource("drawable:clay_ball", setOf(
        ResourceItem(setOf(), "${MD}drawable/clay_ball.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_039_713_298)
internal val Res.drawable.clock: DrawableResource by lazy {
      DrawableResource("drawable:clock", setOf(
        ResourceItem(setOf(), "${MD}drawable/clock.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_426_784_369)
internal val Res.drawable.coal: DrawableResource by lazy {
      DrawableResource("drawable:coal", setOf(
        ResourceItem(setOf(), "${MD}drawable/coal.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(864_530_731)
internal val Res.drawable.coal_block: DrawableResource by lazy {
      DrawableResource("drawable:coal_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/coal_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_056_603_503)
internal val Res.drawable.coal_ore: DrawableResource by lazy {
      DrawableResource("drawable:coal_ore", setOf(
        ResourceItem(setOf(), "${MD}drawable/coal_ore.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_259_413_581)
internal val Res.drawable.coarse_dirt: DrawableResource by lazy {
      DrawableResource("drawable:coarse_dirt", setOf(
        ResourceItem(setOf(), "${MD}drawable/coarse_dirt.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(257_538_547)
internal val Res.drawable.cobblestone: DrawableResource by lazy {
      DrawableResource("drawable:cobblestone", setOf(
        ResourceItem(setOf(), "${MD}drawable/cobblestone.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_710_832_742)
internal val Res.drawable.cobblestone_slab: DrawableResource by lazy {
      DrawableResource("drawable:cobblestone_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/cobblestone_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_025_692_425)
internal val Res.drawable.cobblestone_stairs: DrawableResource by lazy {
      DrawableResource("drawable:cobblestone_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/cobblestone_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_759_382_367)
internal val Res.drawable.cobblestone_wall: DrawableResource by lazy {
      DrawableResource("drawable:cobblestone_wall", setOf(
        ResourceItem(setOf(), "${MD}drawable/cobblestone_wall.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_084_314_684)
internal val Res.drawable.cobweb: DrawableResource by lazy {
      DrawableResource("drawable:cobweb", setOf(
        ResourceItem(setOf(), "${MD}drawable/cobweb.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-668_375_415)
internal val Res.drawable.cocoa_beans: DrawableResource by lazy {
      DrawableResource("drawable:cocoa_beans", setOf(
        ResourceItem(setOf(), "${MD}drawable/cocoa_beans.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_307_219_551)
internal val Res.drawable.cod: DrawableResource by lazy {
      DrawableResource("drawable:cod", setOf(
        ResourceItem(setOf(), "${MD}drawable/cod.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_211_399_258)
internal val Res.drawable.cod_bucket: DrawableResource by lazy {
      DrawableResource("drawable:cod_bucket", setOf(
        ResourceItem(setOf(), "${MD}drawable/cod_bucket.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_001_893_533)
internal val Res.drawable.cod_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:cod_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/cod_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_197_753_126)
internal val Res.drawable.command_block: DrawableResource by lazy {
      DrawableResource("drawable:command_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/command_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_720_710_602)
internal val Res.drawable.command_block_minecart: DrawableResource by lazy {
      DrawableResource("drawable:command_block_minecart", setOf(
        ResourceItem(setOf(), "${MD}drawable/command_block_minecart.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-795_334_548)
internal val Res.drawable.comparator: DrawableResource by lazy {
      DrawableResource("drawable:comparator", setOf(
        ResourceItem(setOf(), "${MD}drawable/comparator.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_009_525_325)
internal val Res.drawable.compass: DrawableResource by lazy {
      DrawableResource("drawable:compass", setOf(
        ResourceItem(setOf(), "${MD}drawable/compass.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(379_089_144)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_986_556_495)
internal val Res.drawable.composter: DrawableResource by lazy {
      DrawableResource("drawable:composter", setOf(
        ResourceItem(setOf(), "${MD}drawable/composter.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-119_318_548)
internal val Res.drawable.conduit: DrawableResource by lazy {
      DrawableResource("drawable:conduit", setOf(
        ResourceItem(setOf(), "${MD}drawable/conduit.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-449_655_533)
internal val Res.drawable.cooked_beef: DrawableResource by lazy {
      DrawableResource("drawable:cooked_beef", setOf(
        ResourceItem(setOf(), "${MD}drawable/cooked_beef.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_119_045_761)
internal val Res.drawable.cooked_chicken: DrawableResource by lazy {
      DrawableResource("drawable:cooked_chicken", setOf(
        ResourceItem(setOf(), "${MD}drawable/cooked_chicken.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_363_082_035)
internal val Res.drawable.cooked_cod: DrawableResource by lazy {
      DrawableResource("drawable:cooked_cod", setOf(
        ResourceItem(setOf(), "${MD}drawable/cooked_cod.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(493_480_074)
internal val Res.drawable.cooked_mutton: DrawableResource by lazy {
      DrawableResource("drawable:cooked_mutton", setOf(
        ResourceItem(setOf(), "${MD}drawable/cooked_mutton.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_622_656_390)
internal val Res.drawable.cooked_porkchop: DrawableResource by lazy {
      DrawableResource("drawable:cooked_porkchop", setOf(
        ResourceItem(setOf(), "${MD}drawable/cooked_porkchop.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_881_709_069)
internal val Res.drawable.cooked_rabbit: DrawableResource by lazy {
      DrawableResource("drawable:cooked_rabbit", setOf(
        ResourceItem(setOf(), "${MD}drawable/cooked_rabbit.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_456_216_398)
internal val Res.drawable.cooked_salmon: DrawableResource by lazy {
      DrawableResource("drawable:cooked_salmon", setOf(
        ResourceItem(setOf(), "${MD}drawable/cooked_salmon.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_148_658_690)
internal val Res.drawable.cookie: DrawableResource by lazy {
      DrawableResource("drawable:cookie", setOf(
        ResourceItem(setOf(), "${MD}drawable/cookie.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(244_491_498)
internal val Res.drawable.cornflower: DrawableResource by lazy {
      DrawableResource("drawable:cornflower", setOf(
        ResourceItem(setOf(), "${MD}drawable/cornflower.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_758_363_158)
internal val Res.drawable.cow_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:cow_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/cow_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_586_622_459)
internal val Res.drawable.cracked_nether_bricks: DrawableResource by lazy {
      DrawableResource("drawable:cracked_nether_bricks", setOf(
        ResourceItem(setOf(), "${MD}drawable/cracked_nether_bricks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_303_773_037)
internal val Res.drawable.cracked_polished_blackstone_bricks: DrawableResource by lazy {
      DrawableResource("drawable:cracked_polished_blackstone_bricks", setOf(
        ResourceItem(setOf(), "${MD}drawable/cracked_polished_blackstone_bricks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-465_645_409)
internal val Res.drawable.cracked_stone_bricks: DrawableResource by lazy {
      DrawableResource("drawable:cracked_stone_bricks", setOf(
        ResourceItem(setOf(), "${MD}drawable/cracked_stone_bricks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(979_722_206)
internal val Res.drawable.crafting_table: DrawableResource by lazy {
      DrawableResource("drawable:crafting_table", setOf(
        ResourceItem(setOf(), "${MD}drawable/crafting_table.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(602_574_756)
internal val Res.drawable.creeper_banner_pattern: DrawableResource by lazy {
      DrawableResource("drawable:creeper_banner_pattern", setOf(
        ResourceItem(setOf(), "${MD}drawable/creeper_banner_pattern.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(933_192_059)
internal val Res.drawable.creeper_head: DrawableResource by lazy {
      DrawableResource("drawable:creeper_head", setOf(
        ResourceItem(setOf(), "${MD}drawable/creeper_head.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_959_385_223)
internal val Res.drawable.creeper_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:creeper_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/creeper_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_987_217_574)
internal val Res.drawable.crimson_button: DrawableResource by lazy {
      DrawableResource("drawable:crimson_button", setOf(
        ResourceItem(setOf(), "${MD}drawable/crimson_button.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable1Resources(map: MutableMap<String, DrawableResource>) {
  map.put("brain_coral", Res.drawable.brain_coral)
  map.put("brain_coral_block", Res.drawable.brain_coral_block)
  map.put("brain_coral_fan", Res.drawable.brain_coral_fan)
  map.put("bread", Res.drawable.bread)
  map.put("brewing_stand", Res.drawable.brewing_stand)
  map.put("brick", Res.drawable.brick)
  map.put("brick_slab", Res.drawable.brick_slab)
  map.put("brick_stairs", Res.drawable.brick_stairs)
  map.put("brick_wall", Res.drawable.brick_wall)
  map.put("bricks", Res.drawable.bricks)
  map.put("brown_banner", Res.drawable.brown_banner)
  map.put("brown_bed", Res.drawable.brown_bed)
  map.put("brown_carpet", Res.drawable.brown_carpet)
  map.put("brown_concrete", Res.drawable.brown_concrete)
  map.put("brown_concrete_powder", Res.drawable.brown_concrete_powder)
  map.put("brown_dye", Res.drawable.brown_dye)
  map.put("brown_glazed_terracotta", Res.drawable.brown_glazed_terracotta)
  map.put("brown_mushroom", Res.drawable.brown_mushroom)
  map.put("brown_mushroom_block", Res.drawable.brown_mushroom_block)
  map.put("brown_shulker_box", Res.drawable.brown_shulker_box)
  map.put("brown_stained_glass", Res.drawable.brown_stained_glass)
  map.put("brown_stained_glass_pane", Res.drawable.brown_stained_glass_pane)
  map.put("brown_terracotta", Res.drawable.brown_terracotta)
  map.put("brown_wool", Res.drawable.brown_wool)
  map.put("bubble_coral", Res.drawable.bubble_coral)
  map.put("bubble_coral_block", Res.drawable.bubble_coral_block)
  map.put("bubble_coral_fan", Res.drawable.bubble_coral_fan)
  map.put("bucket", Res.drawable.bucket)
  map.put("cactus", Res.drawable.cactus)
  map.put("cake", Res.drawable.cake)
  map.put("campfire", Res.drawable.campfire)
  map.put("carrot", Res.drawable.carrot)
  map.put("carrot_on_a_stick", Res.drawable.carrot_on_a_stick)
  map.put("cartography_table", Res.drawable.cartography_table)
  map.put("carved_pumpkin", Res.drawable.carved_pumpkin)
  map.put("cat_spawn_egg", Res.drawable.cat_spawn_egg)
  map.put("cauldron", Res.drawable.cauldron)
  map.put("cave_spider_spawn_egg", Res.drawable.cave_spider_spawn_egg)
  map.put("chain", Res.drawable.chain)
  map.put("chain_command_block", Res.drawable.chain_command_block)
  map.put("chainmail_boots", Res.drawable.chainmail_boots)
  map.put("chainmail_chestplate", Res.drawable.chainmail_chestplate)
  map.put("chainmail_helmet", Res.drawable.chainmail_helmet)
  map.put("chainmail_leggings", Res.drawable.chainmail_leggings)
  map.put("charcoal", Res.drawable.charcoal)
  map.put("chest", Res.drawable.chest)
  map.put("chest_minecart", Res.drawable.chest_minecart)
  map.put("chicken", Res.drawable.chicken)
  map.put("chicken_spawn_egg", Res.drawable.chicken_spawn_egg)
  map.put("chipped_anvil", Res.drawable.chipped_anvil)
  map.put("chiseled_nether_bricks", Res.drawable.chiseled_nether_bricks)
  map.put("chiseled_polished_blackstone", Res.drawable.chiseled_polished_blackstone)
  map.put("chiseled_quartz_block", Res.drawable.chiseled_quartz_block)
  map.put("chiseled_red_sandstone", Res.drawable.chiseled_red_sandstone)
  map.put("chiseled_sandstone", Res.drawable.chiseled_sandstone)
  map.put("chiseled_stone_bricks", Res.drawable.chiseled_stone_bricks)
  map.put("chorus_flower", Res.drawable.chorus_flower)
  map.put("chorus_fruit", Res.drawable.chorus_fruit)
  map.put("chorus_plant", Res.drawable.chorus_plant)
  map.put("clay", Res.drawable.clay)
  map.put("clay_ball", Res.drawable.clay_ball)
  map.put("clock", Res.drawable.clock)
  map.put("coal", Res.drawable.coal)
  map.put("coal_block", Res.drawable.coal_block)
  map.put("coal_ore", Res.drawable.coal_ore)
  map.put("coarse_dirt", Res.drawable.coarse_dirt)
  map.put("cobblestone", Res.drawable.cobblestone)
  map.put("cobblestone_slab", Res.drawable.cobblestone_slab)
  map.put("cobblestone_stairs", Res.drawable.cobblestone_stairs)
  map.put("cobblestone_wall", Res.drawable.cobblestone_wall)
  map.put("cobweb", Res.drawable.cobweb)
  map.put("cocoa_beans", Res.drawable.cocoa_beans)
  map.put("cod", Res.drawable.cod)
  map.put("cod_bucket", Res.drawable.cod_bucket)
  map.put("cod_spawn_egg", Res.drawable.cod_spawn_egg)
  map.put("command_block", Res.drawable.command_block)
  map.put("command_block_minecart", Res.drawable.command_block_minecart)
  map.put("comparator", Res.drawable.comparator)
  map.put("compass", Res.drawable.compass)
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("composter", Res.drawable.composter)
  map.put("conduit", Res.drawable.conduit)
  map.put("cooked_beef", Res.drawable.cooked_beef)
  map.put("cooked_chicken", Res.drawable.cooked_chicken)
  map.put("cooked_cod", Res.drawable.cooked_cod)
  map.put("cooked_mutton", Res.drawable.cooked_mutton)
  map.put("cooked_porkchop", Res.drawable.cooked_porkchop)
  map.put("cooked_rabbit", Res.drawable.cooked_rabbit)
  map.put("cooked_salmon", Res.drawable.cooked_salmon)
  map.put("cookie", Res.drawable.cookie)
  map.put("cornflower", Res.drawable.cornflower)
  map.put("cow_spawn_egg", Res.drawable.cow_spawn_egg)
  map.put("cracked_nether_bricks", Res.drawable.cracked_nether_bricks)
  map.put("cracked_polished_blackstone_bricks", Res.drawable.cracked_polished_blackstone_bricks)
  map.put("cracked_stone_bricks", Res.drawable.cracked_stone_bricks)
  map.put("crafting_table", Res.drawable.crafting_table)
  map.put("creeper_banner_pattern", Res.drawable.creeper_banner_pattern)
  map.put("creeper_head", Res.drawable.creeper_head)
  map.put("creeper_spawn_egg", Res.drawable.creeper_spawn_egg)
  map.put("crimson_button", Res.drawable.crimson_button)
}
